/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRotateDot = createReactComponent("outline", "rotate-dot", "IconRotateDot", [["path", { "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }]]);

export { IconRotateDot as default };
//# sourceMappingURL=IconRotateDot.mjs.map
